import { Component, inject, Input } from '@angular/core'
import { ComponentWithCopy } from '../../intefaces/interfaces'
import { HeadlineLarge } from '../../components/typography/headline-large/headline-large'
import { BodyLarge } from '../../components/typography/body-large/body-large'
import { AnimateOnScroll } from 'primeng/animateonscroll'
import { SharedContent } from '../../services/shared-content/shared-content'
import { Link } from '../../components/link/link'
@Component({
	selector: 'app-feature-copy-with-image-right',
	imports: [HeadlineLarge, BodyLarge, AnimateOnScroll, Link],
	templateUrl: './feature-copy-with-image-right.html',
	styleUrl: './feature-copy-with-image-right.css',
})
export class FeatureCopyWithImageRight {
	@Input() content!: ComponentWithCopy

	private sharedContentService = inject(SharedContent)

	ctaButtonClicked(path: string): void {
    this.sharedContentService.navigateTo(path)
  }
}
